import { createSelector } from '@reduxjs/toolkit';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { getHighlightsItems } from 'component/page/detail/Highlights/ActivitiesHighlights.utils';
import { selectActivityHighlightsFromContentDetailState, selectDetailState } from 'component/page/detail/store/detail.selectors';
import { StateProps } from 'component/page/detail/Highlights/ActivitiesHighlights.types';
import { selectScreenSize } from 'store/slice/screen';

export const mapStateToProps = createSelector(
    selectCmsFromBootstrap,
    selectDetailState,
    selectActivityHighlightsFromContentDetailState,
    selectScreenSize,
    (cms, detailState, highlightsResponse, screenSize): StateProps => ({
        cms,
        isLoading: detailState.isLoading,
        highlightsItems: getHighlightsItems(highlightsResponse),
        isMobile: screenSize.mobile,
    }),
);
